import React, { Fragment } from 'react';
import { StyleSheet, View } from 'react-native';
import { Icon, Text } from '@ui-kitten/components';
import lodashIsEmpty from 'lodash/isEmpty';
import PropTypes from 'prop-types';

import Button from '../../Components/Button';
import ItemTag from '../../Components/Card/ItemTag';
import ReadMore from '../../Components/ReadMore';
import ScreenBanner from '../../Components/ScreenBanner';
import modals from '../../Components/Sheets/modals';
import AnalyticsHelper from '../../Helper/Analytics';
import MenuItemHelper from '../../Helper/MenuItem';
import { getCartTerm } from '../../Helper/RemoteConfig';
import ThemeColor from '../../Theme/colors';
import ThemeStyle from '../../Theme/styles';
import { SECTION_SUB_TITLE, SECTION_TITLE } from '../../Theme/typographyProps';

const cartIconSize = 25;

export const RenderItemInfo = ({ data, stock, style }) => {
  return (
    <View style={style}>
      <Text style={ThemeStyle.spacingBottomSmall} {...SECTION_TITLE}>
        {data.name}
      </Text>
      <View
        style={[
          ThemeStyle.flexWrap,
          ThemeStyle.flexDirectionRowCenter,
          ThemeStyle.spacingBottomSmall,
        ]}
      >
        <ItemTag
          stock={stock}
          style={[ThemeStyle.spacingBottomSmall, ThemeStyle.spacingRightSmall]}
          tagLimit={-1}
          tags={data?.tags}
        />
      </View>
      {Boolean(data.description) && (
        <ReadMore
          contentContainerStyle={ThemeStyle.dimColor}
          maxChar={150}
          value={data.description}
          {...SECTION_SUB_TITLE}
        />
      )}
      {MenuItemHelper.showDiscountDescription(data) && (
        <Text
          style={[ThemeStyle.noticeText, ThemeStyle.spacingTopSmall]}
          {...SECTION_SUB_TITLE}
        >
          {data.discount_description}GG
        </Text>
      )}
      {stock > 0 && (
        <Text
          style={[ThemeStyle.noticeText, ThemeStyle.spacingTopSmall]}
          {...SECTION_SUB_TITLE}
        >
          {stock} Items left!
        </Text>
      )}
    </View>
  );
};

class ProductHeading extends React.PureComponent {
  _onStoreNamePressed = () => {
    const { productData, setParams } = this.props;
    setParams({ id: productData.store.id });
  };

  _onEditPressed = async () => {
    const { setParams, thisProductOnCart } = this.props;
    const shouldOpenSlideUpModal = thisProductOnCart.length > 1;

    if (shouldOpenSlideUpModal) {
      await modals.hide(modals.PRODUCT); // hide product first
      await modals.show(modals.MULTIPLE_VARIANT, { items: thisProductOnCart }); // then show the multivariant modal
    } else {
      const cartItem = thisProductOnCart[0];
      AnalyticsHelper.itemSelection({ ...cartItem, fromSection: 'Edit Item' });
      setParams({ isUpdate: true, id: cartItem.item_id, ...cartItem });
    }
  };

  render() {
    const { productData, stock, thisProductOnCart } = this.props;
    const isOnCart = !lodashIsEmpty(thisProductOnCart);
    let totalCart = 0;

    if (isOnCart) {
      totalCart = thisProductOnCart.reduce((acc, a) => acc + a.quantity, 0);
    }

    return (
      <Fragment>
        <ScreenBanner banner={productData.image} isProductPage />

        <RenderItemInfo
          data={productData}
          stock={stock}
          style={[
            ThemeStyle.pageVerticalSpacingMedium,
            ThemeStyle.pageHorizontalSpacing,
          ]}
        />

        {isOnCart && (
          <Fragment>
            <View
              style={[
                ThemeStyle.flexDirectionRowCenterSpaceBetween,
                ThemeStyle.pageHorizontalSpacing,
                ThemeStyle.spacingBottomMedium,
              ]}
            >
              <View style={ThemeStyle.flexDirectionRowCenter}>
                <Icon
                  name="shopping-cart-outline"
                  fill={ThemeColor.green}
                  style={[
                    styles.productOnCartIcon,
                    ThemeStyle.spacingRightMedium,
                  ]}
                />
                <Text {...SECTION_SUB_TITLE}>
                  {totalCart}&times; in your {getCartTerm()}
                </Text>
              </View>

              <Button
                testID="editButton"
                onPress={this._onEditPressed}
                style={styles.productOnCartEditButton}
                plain
              >
                <Text {...SECTION_SUB_TITLE}>Edit</Text>
              </Button>
            </View>
          </Fragment>
        )}
      </Fragment>
    );
  }
}

const styles = StyleSheet.create({
  productOnCartIcon: {
    width: cartIconSize,
    height: cartIconSize,
  },
  productOnCartEditButton: {
    ...ThemeStyle.pageVerticalSpacingSmall,
    ...ThemeStyle.pageHorizontalSpacingSmall,
    backgroundColor: ThemeColor.gray,
    borderRadius: 50,
  },
});

ProductHeading.propTypes = {
  productData: PropTypes.object.isRequired,
  thisProductOnCart: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
};

export default ProductHeading;
